module.exports = __webpack_public_path__ + "static/img/10.b641be1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/10.png
// module id = BlCr
// module chunks = 0